import * as React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'

function SvgForwards(props) {
	return (
		<SvgIcon {...props}>
			<path
				d="M18.6 13.5a7 7 0 11-7-7h6.1l-4-3.5"
				stroke="currentColor"
				strokeWidth={1.2}
				fill="none"
				fillRule="evenodd"
				strokeLinecap="round"
			/>
		</SvgIcon>
	)
}

export default SvgForwards
